import { FC, PropsWithChildren } from 'react';

import QueryParam from '../injections/QueryParam';

/**
 * Композиция для страницы с неавторизованным пользователем
 * @param root0 Пропсы
 * @param root0.children Дочерние элементы
 */
export const LoggedOutUserComposition: FC<PropsWithChildren> = ({
  children
}) => {
  return <QueryParam>{children}</QueryParam>;
};
